/**
 *  @file: main.js is a <js> file
 *  @author:  shangwenhe
 */

import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js';
import VueLazyload from 'vue-lazyload';
import { lgSa } from '@lagou/kw-lgsa';
import { isApp, isLgApp, isEduApp, isPC } from './uitl/getVersion';
import MetaInfo from 'vue-meta-info';
import './static/less/reset.less';
import './static/js/flexible';
// Vue.use(MetaInfo);
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import FooterPoup from './components/FooterPoup/index.vue'
import ClueFooter from './components/ClueFooter/index.vue'

window.appBeforeGoBack = window.appBeforeGoBack || (() => true)

Vue.use(ElementUI);
Vue.config.productionTip = false;
import { fetchUserInfo } from './service/api'
import { getParam, getUUID } from './uitl/getParam';
// 重写 XMLHttpRequest open 方法
if (window.XMLHttpRequest && !XMLHttpRequest.rewrite) {
  let open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, async) {
    let version = '1.0.2';
    if (/\/\/vod.lagou.com/.test(url)) {
      url = url.replace(/https:\/\/vod.lagou.com/, 'https://edu-vod.lagou.com');
    }
    // 将kaiwu 或者 edu alikey 更换为当前域名的 location.host/alikey
    if (/https:\/\/(kaiwu|edu).lagou.com\/alikey/.test(url)) {
      url = url.replace(/(kaiwu|edu).lagou.com/ig, window.location.host);
    }
    open.call(this, method, url, async);
    // 只有 包含 .lagou.com 的url才 添加 authoration
    if (/^\/[^/]|^https?\:\/\/[^./]+\.lagou\.com|^\/\/[^./]+\.lagou\.com/.test(url) && !/shenceyun\.lagou\.com/.test(url)) {
      this.setRequestHeader('Authorization', Cookies.get('gate_login_token'));
      // this.withCredentials = true;
    }
    XMLHttpRequest.rewrite = true;
  };
}

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta.content) {
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  next()
})

// 初始化懒加载指令
Vue.use(VueLazyload,
  {
    preLoad: 2.5,
    throttleWait: 0,
    observer: true,
    lazyComponent: true,
    observerOptions: {
      rootMargin: '200px',
      threshold: 0.1
    }
  }
);
Vue.mixin({
  data() {
    return {
      isApp: isApp(),
      isLgApp: isLgApp(),
      isEduApp: isEduApp(),
      isPC: isPC(),
      userId: '',
      fetching: true
    }
  },
  components: {
    FooterPoup,
    ClueFooter
  },
  computed: {
    firstBtnType() {
      let idStr = this.userId + '';
      let newbtnArr = [1, 2, 3, 4, 5];
      let id = idStr && parseInt(idStr.charAt(idStr.length - 1));
      return newbtnArr.includes(id);
    },
    secondBtnType() {
      let idStr = this.userId + '';
      let newbtnArr = [1, 2, 3];
      let id = idStr && parseInt(idStr.charAt(idStr.length - 1));
      return newbtnArr.includes(id);
    },
    secondBtnTypeHasTip() {
      let idStr = this.userId + '';
      let newbtnArr = [4, 5, 6];
      let id = idStr && parseInt(idStr.charAt(idStr.length - 1));
      return newbtnArr.includes(id);
    }
  },
  methods: {
    saLogin() {
      fetchUserInfo().then(res => {
        if (res.state == 1) {
          let { id } = res.content;
          this.userId = id;
          if (id) {
            window.sa && window.sa.login(id);
            lgSa.lgSaRegister({
              user_id: id
            })
          } else {
            let first_id = window.sa && window.sa.store && window.sa.store.getFirstId();
            window.sa && first_id && window.sa.logout(true);
          }
        }
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.fetching = false;
      });
    },
    // 测试环境埋点上报
    // eduPlatTrack(events, props = {}) {
    //     lgSa.eduPlatTrack(events, Object.assign({
    //         sid: `${getParam('sid') || ''}`
    //     }, props), true);
    // },
    //正式环境埋点上报
    eduPlatTrack(events, props = {}) {
      console.log("神策埋点已停止")
      // lgSa.eduPlatTrack(events, Object.assign({
      //   sid: ''
      // }, props));
    },
    platTrack(events, props = {}) {
      const utm_source = getParam('utm_source') || '';
      const ad_id = getParam('ad_id') || '';
      let visitor_uid = localStorage.getItem('visitor_uid') || getUUID();
      localStorage.setItem('visitor_uid', visitor_uid);
      let biz_tpye = '';
      if (isPC()) {
        biz_tpye = getParam('biz_tpye') || -1;
      } else {
        biz_tpye = isEduApp() ? 0 : isLgApp() ? 1 : -1;
      }
      lgSa.platTrack(events, Object.assign({
        biz_tpye,
        utm_source,
        ad_id,
        visitor_uid
      }, props));
    },
    //跳转链接
    goHref(url, hideTitle = 0) {
      if (url) {
        if (url.indexOf('.lagou.com') < 0 && !/^http/.test(url)) {
          url = window.location.origin + url;
        }
        if (this.isEduApp) {
          window.location.href = `lgedu://lgedu.com/h5/open?url=${encodeURIComponent(url)}&hideTitle=${hideTitle}`;
        } else if (this.isLgApp) {
          window.location.href = `lagou://lagou.com/h5/open?url=${encodeURIComponent(url)}&hideTitle=${hideTitle}`;
        } else {
          window.location.href = url;
        }
      }
    }
  },
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
